import keyBy from 'lodash/keyBy';
import useAppStore from 'store/useAppStore';

export const getScript = (script) => {
  const { 起始工站, 移動設備, 目標工站, ...rest } = script;
  const stations = keyBy(useAppStore.getState().stations, 'id');
  const materialDevices = keyBy(useAppStore.getState().materialDevices, 'id');
  return {
    ...rest,
    起始工站:
      起始工站.id === 'NotFound'
        ? 起始工站.content
        : `${stations[起始工站.id]['項目']} - ${stations[起始工站.id]['類別']}`,
    移動設備:
      移動設備.id === 'NotFound'
        ? 移動設備.content
        : `${materialDevices[移動設備.id]['項目']} - ${materialDevices[移動設備.id]['類別']}`,
    目標工站:
      目標工站.id === 'NotFound'
        ? 目標工站.content
        : `${stations[目標工站.id]['項目']} - ${stations[目標工站.id]['類別']}`,
  };
};
export const getScripts = (scripts) => {
  return scripts.map((script) => getScript(script));
};
